import React from 'react';
import {ContainerFileDinhKem} from 'components/upload';
import { connect } from 'react-redux';
import { Dialog } from "@blueprintjs/core";
import {
  DropDownChonKetLuanNoiDungKhieuNai,
  DropDownKetQuaGiaiQuyetDon,
  DropDownChonCoQuanDieuTra,
  DropDownNguoiKy,
  DropDownChonKetQuaGiaiQuyet
} from 'components/tt-forms';
import moment from 'moment';
import { GiaiQuyetDonThu, DuLieuHeThong} from 'api';
import { Link } from 'react-router';
import { ShowIf, ShowIfCheck } from 'components/utils';
import { TextArea, DatePicker, Input, InputNumber, Text, TextMessage } from 'components/tt-forms/common';
import ConfirmDialog from './ConfirmDialog.jsx';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import {BlockBaoCaoKQTTXM} from 'modules/giai-quyet-don/subView';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class LapDuThaoCanBo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.id,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      open: false,
      onSave: false,
      loaiDon: this.props.loaiDon,
      gqText: (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') ? 'Ban hành văn bản giải quyết' : ((this.props.loaiDon == 'DON_TO_CAO') ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết'),
      valueKetQua: '',

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      tenDonViTheoDoiThucHien: '',
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      nextState: 'KET_THUC',
      donViTheoDoiThucHien: '',
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',
      noiDungDoiThoai: '',

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataDonViTheoDoi: [],
      dataCoQuanTheoDoi: [],
      dataDonViNhanTDTH: [],
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      ngayHetHanGiaiQuyetTTXMLai: '',
      ngayHetHanTTXMLai: '',
      noiDungGiaoTTXMLai: '',
      openDialogGiaoTTXML: false,
      message: '',
      dataKetQuaGiaiQuyetDon: [],
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: ''
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.getDonViTheoDoi();
    this.getCoQuanTheoDoiEnumn();
    this.getListDonViNhanTDTH();
    this.getDonViNhanTDTH();
    this.getThoiHanGQDonMacDinh();
    this.getThoiHanTTXMMacDinh();
    this.getKetQuaGiaiQuyetDon();
    if (window.debug) {
      console.log('giai-quyet-don/subView/LapDuThaoCanBo');
    }
  }

  getThoiHanGQDonMacDinh() {
    DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, {type: this.props.loaiDon}).then(res => {
      let thoiHanXuLyMacDinh = new Date(res.data);
      this.setState({
        ngayHetHanGiaiQuyetTTXMLai: thoiHanXuLyMacDinh
      })
    })
  }

  getThoiHanTTXMMacDinh() {
    let params = {
      type: this.props.loaiDon
    }
    if ((this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO') && this.state.ngayRaThongBaoTTXM && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
      params.ngayRaThongBaoTTXM = moment(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(res => {
      let thoiHanXuLyMacDinh = new Date(res.data);
      this.setState({
        ngayHetHanTTXMLai: thoiHanXuLyMacDinh
      })
    })
  }

  getKetQuaGiaiQuyetDon() {
    let params = {
      banHanhQuyetDinh: true,
      khongCoDoiThoai: false,
      loaiDon: this.props.loaiDon
    }
    GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(res => {
      if (res.data) {
        this.setState({
          dataKetQuaGiaiQuyetDon: res.data
        })
      }
    })
  }

  getListDonViNhanTDTH() {
    GiaiQuyetDonThu.actions.getListDonViNhanTDTH.request().then(res => {
      if(res.data._embedded) {
        this.setState({
          dataDonViNhanTDTH: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getDonViNhanTDTH() {
    let params = {
      donId: Number(this.state.id),
      loaiDon: this.state.loaiDon
    }
    GiaiQuyetDonThu.actions.getDonViNhanTDTH.request('', params).then(res => {
      if(res.data) {
        this.setState({
          donViTheoDoiThucHien: res.data.coQuanQuanLyId,
          tenDonViTheoDoiThucHien: res.data.ten
        })
      }
    })
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        })
      }
    })
  }

  getDonViTheoDoi() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
      this.setState({
        id: nextProps.id,
        role: nextProps.role,
        thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId,
        coQuanQuanLyId: nextProps.coQuanQuanLyId,
        coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung
      });
      this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
    }
  }

  onClickClose() {
    this.props.handleBack();
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            nextState: 'KET_THUC',

            ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : (res.data.ketLuanNoiDungKhieuNaiGiaoTTXM ? res.data.ketLuanNoiDungKhieuNaiGiaoTTXM : ''),

            doiThoai: res.data.doiThoai,
            thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
            diaDiemDoiThoai: res.data.diaDiemDoiThoai,

            coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
            soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
            soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
            soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

            soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
            ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
            nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

            giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
            quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
            theoDoiThucHien: res.data.theoDoiThucHien,

            tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
            tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
            datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
            datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
            soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

            soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
            ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
            showTienDoGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet && res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') ? true : false,

            soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
            ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
            noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',

            ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
            lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

            noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
            noiDungGiaoTTXMLai: res.data.noiDungGiaoTTXMLai || ''
          }, ()=> {
            this.renderAttachFile();
            this.checkFileCoQuanDieuTra()
          });
          if (res.data.ngayHetHanGiaiQuyetTTXMLai) {
            this.setState({ngayHetHanGiaiQuyetTTXMLai: new Date(res.data.ngayHetHanGiaiQuyetTTXMLai)});
          }
          if (res.data.ngayHetHanTTXMLai) {
            this.setState({ngayHetHanTTXMLai: new Date(res.data.ngayHetHanTTXMLai)});
          }
        }
      });
    }
  }

  checkFileCoQuanDieuTra() {
    this.setState({
      allowAttachGiaoCoQuanDieuTra: false
    }, () => {
      if (this.state.giaoCoQuanDieuTra == false) {
        this.setState({
          allowAttachGiaoCoQuanDieuTra: true
        })
      } else {
        let taiLieuVanThuGiaoCoQuanDieuTra = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let dataCheck = data.filter(state => {
          return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
        });

        if (dataCheck.length > 0) {
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
            allowAttachGiaoCoQuanDieuTra: true
          })
        } else {
          let newItem = {
            ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
            newFile: true
          }
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: [
              ...taiLieuVanThuGiaoCoQuanDieuTra,
              newItem
            ],
            allowAttachGiaoCoQuanDieuTra: true
          })
        }
      }
    })
  }

  handleChangeDate(name, e) {
    let date = e;
    if (e && e._d) {
      date = e._d;

    }
    this.setState({
      [name]: date
    }, () => {
      if (name == 'ngayRaThongBaoTTXM') {
        this.setState({
          loaiVanBanSuggest: 'VB_GTTXML',
          ngayQuyetDinhSuggest: this.state.ngayRaThongBaoTTXM
        });
        this.getThoiHanTTXMMacDinh();
      }
      this.props.handleChangeData();
    });
  }

  onChange(name, e) {
    if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      this.state.message = `Chọn "${this.state.gqText}" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?`;
      this.state.open = true;
      this.state.valueKetQua = e.target.value;

    } else if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
      this.state.open = true;
      this.state.valueKetQua = e.target.value;
    } else {
      this.setState({
        [name]: e.target.value
      });

      if (name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi') {

      }

    }
    if (name=='ketQuaXLDGiaiQuyet') {
      this.setState({
        allowAttach: false
      },()=> {
        this.renderAttachFile();
      })
    }
    this.props.handleChangeData();
  }

  onFileChange(data, type) {
    let dataFileDinhKem = {...this.state.dataFileDinhKem};
    if (type == 'QUYET_DINH_GIAI_QUYET') {
      dataFileDinhKem.quyetDinhGiaiQuyet = data;
      let fileQD = data.filter(item => {
        return item.typeRequired == 'QDGQ_LDT'
      });
      this.setState ({ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : ''});
    } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
      dataFileDinhKem.giaoCoQuanDieuTra = data;
    } else if (type == 'GIA_HAN') {
      dataFileDinhKem.giaHan = data;
    } else {
      dataFileDinhKem.data = data
      let ttxmlDate = data.filter(item => {
        return item.typeRequired == 'VB_GTTXML';
      });
      if (ttxmlDate.length) {
        this.state.ngayRaThongBaoTTXM = ttxmlDate[0].ngayQuyetDinh;
      }
      this.getThoiHanTTXMMacDinh();
    }
    this.setState ({
      dataFileDinhKem: dataFileDinhKem
    });
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    if (type == 'QUYET_DINH_GIAI_QUYET') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.quyetDinhGiaiQuyet = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaoCoQuanDieuTra = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.props.handleChangeData();

  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);

    if(this.state.giaoCoQuanDieuTra) {

      params.giaoCoQuanDieuTra = true;
      if (this.state.coQuanDieuTra) {
        params.coQuanDieuTra =  {
          id: Number(this.state.coQuanDieuTra)
        }
      }
      params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
      params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);

      if (this.state.khoiTo) {
        params.khoiTo = true;
        params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
        params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
      } else {
        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

    } else {
      params.giaoCoQuanDieuTra = false;
      params.coQuanDieuTra = null;
      params.soVuGiaoCoQuanDieuTra = 0;
      params.soDoiTuongGiaoCoQuanDieuTra = 0;

      params.khoiTo = false;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;
    }

    if(this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      params.quyetDinhGiaiQuyetKhieuNai = true;
      params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;
      params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

      if (this.props.donInfo.layVuViecCu === true) {
        params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
      } else {
        params.ketQuaGiaiQuyetLan2 = null;
      }

      if (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && this.props.donInfo.layVuViecCu === true) {
        params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
      } else {
        params.noiDungKetLuanGiaiQuyetLai = '';
      }
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;

      params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
      params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
      params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
      params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

      params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
      params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
      params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
      params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
      params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
    } else {
      params.quyetDinhGiaiQuyetKhieuNai = false;

      params.soLanGiaiQuyetLai = 0;
      params.ketQuaGiaiQuyetKhac = '';

      params.ketQuaGiaiQuyetLan2 = null;
      params.noiDungKetLuanGiaiQuyetLai = '';

      params.tienPhaiThuNhaNuocQDGQ = 0;
      params.tienPhaiTraCongDanQDGQ = 0;
      params.datPhaiThuNhaNuocQDGQ = 0;
      params.datPhaiTraCongDanQDGQ = 0;
      params.soVuGiaiQuyetKhieuNai = 0;
      params.ketLuanNoiDungKhieuNai = null;
      params.tongSoNguoiXuLyHanhChinh = 0;
      params.soNguoiDaBiXuLyHanhChinh = 0;
      params.soNguoiDuocTraLaiQuyenLoi = 0;
    }
    if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
    }

    params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : null;

    params.quyetDinhGiaiQuyetKhieuNai = true;
    params.soVuGiaiQuyetKhieuNai = this.state.soVuGiaiQuyetKhieuNai;

    params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

    if (this.state.loaiDon == 'DON_TO_CAO') {
      if(this.state.doiThoai) {
        params.doiThoai = true;
        params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? moment(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
        params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
        params.noiDungDoiThoai = this.state.noiDungDoiThoai;
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }
    } else {
      params.doiThoai = false;
      params.thoiGianDoiThoai = null;
      params.diaDiemDoiThoai = '';
      params.noiDungDoiThoai = '';
    }
    if (this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
      params.ngayHetHanGiaiQuyetTTXMLai = this.state.ngayHetHanGiaiQuyetTTXMLai ? moment(this.state.ngayHetHanGiaiQuyetTTXMLai).add(7, 'hours').toISOString() : null;
      params.ngayHetHanTTXMLai = this.state.ngayHetHanTTXMLai ? moment(this.state.ngayHetHanTTXMLai).add(7, 'hours').toISOString() : null;
      params.noiDungGiaoTTXMLai = this.state.noiDungGiaoTTXMLai || '';
    }
    return params;
  }

  handleSave() {
    this.setState({
      onSave: true
    }, ()=> {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDinhKem = this.getListDataFileDinhKem();

      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ]
        dataFile.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }

      if (!this.state.giaoCoQuanDieuTra) {
        let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra]
        dataFile.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let params = this.getParams();

      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.props.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        });
      });
    })
  }

  handleKetThuc(name) {
    this.setState({
      onSave: false
    }, ()=> {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        let dataFileDinhKem = this.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
          let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ]
          dataFile.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (!this.state.giaoCoQuanDieuTra) {
          let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra]
          dataFile.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let _params = this.getParams();
        let params = {};
        let msgName = '';

        if (this.props.tuGiaiQuyet) {
          if (name == 'openDialogGiaoTTXML') {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              actionType: 'GQD_GIAO_TTXM_LAI'
            }
            msgName = 'guiTTXMLai';
          } else {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              donViTheoDoiThucHien: {
                id: Number(this.state.donViTheoDoiThucHien)
              },
              // actionType: 'GQD_NHAN_BAO_CAO_TTXM' => bước này lưu hồ sơ
              actionType: 'QGD_GUI_YEU_CAU_TDTH'
            };
            _params.donViTheoDoiThucHien = {
              id: Number(this.state.donViTheoDoiThucHien)
            };
            msgName = 'gqdLuuHoSo';
          }
        } else {
          if (name == 'openDialog') {
            let selectedState = this.props.dataNextStates.filter(state => {
              return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN'
            });
            _params.donViTheoDoiThucHien = {
              id: Number(this.state.donViTheoDoiThucHien)
            };

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              donViTheoDoiThucHien: {
                id: Number(this.state.donViTheoDoiThucHien)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              }
            }
            params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhDinhChi;
            if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
              params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
            }
            msgName = 'gqdChuyenTheoDoi';
          } else if (name == 'openDialogGiaoTTXML') {
            let selectedState = this.props.dataNextStates.filter(state => {
              return state.type == 'CAN_BO_GIAO_TTXM_LAI'
            });
            params = {
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              thongTinGiaiQuyetDon: {
                id: Number(this.props.thongTinGiaiQuyetDonId)
              },
              yKienGiaiQuyet: this.state.noiDungGiaoTTXMLai
            }
            msgName = 'guiTTXMLai';
            if (this.state.ngayRaThongBaoTTXM) {
              params.ngayRaThongBaoTTXM = moment(this.state.ngayRaThongBaoTTXM).add(7, 'hours').toISOString();
            }
          }
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.updateGiaiQuyetDon(_params, params, msgName);
            });
          });
        });
      }
    })
  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
      Data.quyetDinhGiaiQuyet.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
      Data.giaoCoQuanDieuTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaHan.length > 0 && (this.state.giaHanGiaiQuyet)) {
      Data.giaHan.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    })
    if (name =='giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    if (!e) {

    }
    this.props.handleChangeData();
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
    this.props.handleChangeData();
  }
  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        [name]: true
      })
    }
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    })
  }
  onSuccess(name) {
    this.closeDialog(name);
    this.handleKetThuc(name);
  }

  closeDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
    },()=> {
      this.renderAttachFile();
    })
  }

  onSuccessDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.valueKetQua
    },()=> {
      this.renderAttachFile();
    })
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime > secondTime || (firstTime == secondTime && type == 'show')) {
      return true
    } else {
      return false
    }
  }

  renderAttachFile() {
    let DataTaiLieuVanThu = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let DataTaiLieuVanThuView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];

    let listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
    })

    let listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
      return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
    });

    let dataTTXML = DataTaiLieuVanThu.filter(item => {
      return item.typeRequired == 'VB_GTTXML'
    });

    if (this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !dataTTXML.length) {
      listTaiLieuVanThuGiaiQuyetDon = [...listTaiLieuVanThuGiaiQuyetDon, {
        ten: this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Văn bản xác minh nội dung kiến nghị, phản ánh lại' : 'Văn bản giao TTXM lại',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'VB_GTTXML',
        newFile: true
      }];
    }

    this.setState({
      listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
      listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
      allowAttach: true
    })
  }

  render() {
    let ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(state => {
      return state.giaTri == this.state.ketQuaXLDGiaiQuyet
    });
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    return (
      <section className="wrap-block">
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <BlockBaoCaoKQTTXM donInfo={this.props.donInfo} thongTinGQD={this.state.dataGiaiQuyetDon}/>

            <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet}>
              <div>
                <div className="col-100">
                  <h3 className="text-12 txt-upper txt-bold mb10 mt0">Gia hạn giải quyết tố cáo</h3>
                </div>
                <Text className="col-25 mb10" red={true} label="Gia hạn đến ngày:" value={this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : ''}/>
              </div>
            </ShowIf>
          </div>
        </div>
        <div className="row pl15 pr15">
          <div className="wrap-big-line pt5 pb20">
            <span className="big-border"></span>
          </div>

          <div className="col-100 no-gutter mt5">
            <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
            <div className="row pl10 pr10">
              <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
              <ShowIf condition={this.state.showTienDoGiaiQuyet == false}>
                <DropDownKetQuaGiaiQuyetDon name="tienDoGiaiQuyet" disable={this.state.ketQuaXLDGiaiQuyet != '' && this.state.ketQuaXLDGiaiQuyet != 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false} confirm={true} className="col-25" selectedValue={this.state.ketQuaXLDGiaiQuyet} onChange={this.onChange.bind(this, 'ketQuaXLDGiaiQuyet')} isTTXMLai={this.props.isTTXMLai} loaiDon={this.props.loaiDon}/>
              </ShowIf>
              <ShowIf condition={this.state.showTienDoGiaiQuyet == true}>
                <Text className="col-25 mb10" label='' value={ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : ''}/>
              </ShowIf>
            </div>
          </div>
          <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !this.props.isTTXMLai}>
            <DatePicker require
              className="col-25"
              value={this.state.ngayHetHanGiaiQuyetTTXMLai}
              label='Hạn giải quyết'
              name="ngayHetHanGiaiQuyetTTXMLai"
              startDate={moment(new Date()).subtract(1, "days")}
              onChange={this.handleChangeDate.bind(this, 'ngayHetHanGiaiQuyetTTXMLai')}
              bindValidator={this}
              channel="formTaoDon" />
            {
              this.props.loaiDon == 'DON_TO_CAO' &&
              <DatePicker require
                className="col-25"
                value={this.state.ngayRaThongBaoTTXM}
                label={`Ngày ra văn bản ${lb1} lại`}
                name="ngayRaThongBaoTTXM"
                onChange={this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM')}
                bindValidator={this}
                channel="formTaoDon" />
            }
            <DatePicker require
              className="col-25"
              value={this.state.ngayHetHanTTXMLai}
              label='Thời gian báo cáo kết quả'
              name="ngayHetHanTTXMLai"
              startDate={moment(new Date()).subtract(1, "days")}
              onChange={this.handleChangeDate.bind(this, 'ngayHetHanTTXMLai')}
              bindValidator={this}
              channel="formTaoDon" />
            <TextArea
              label="Ý kiến xử lý"
              rows="3"
              placeholder="Nhập ý kiến"
              value={this.state.noiDungGiaoTTXMLai}
              onChange={this.onChange.bind(this, 'noiDungGiaoTTXMLai')}
              name="textareaYKienTTXM" />
          </ShowIf>

          <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>

            <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
              <h3 className="txt-upper title-14 mt0 mb15">Quyết định giải quyết tố cáo</h3>
            </ShowIf>
            <ShowIf condition={this.props.loaiDon == 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
              <h3 className="txt-upper title-14 mt0 mb15">Quyết định giải quyết khiếu nại</h3>
            </ShowIf>
            <ShowIf condition={this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
              <h3 className="txt-upper title-14 mt0 mb15">Văn bản giải quyết kiến nghị, phản ánh</h3>
            </ShowIf>
            <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
              <h3 className="txt-upper title-14 mt0 mb15">Quyết định đình chỉ</h3>
            </ShowIf>

            <div className="row pl10 pr10">
              <Input triggeOnBlur={true} className="col-25" name="inputSoVanBan" label="Số văn bản" bindValidator={this} channel="formTaoDon" require value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} maxLength={255} />
              <DatePicker className="col-25" label="Ngày ban hành" endDate={new Date()} bindValidator={this} channel="formTaoDon" require value={this.state.ngayBanHanh} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')} name="inputNgayBanHanh"/>
              <DropDownNguoiKy selected={this.state.nguoiBanHanh} onChange={this.onChange.bind(this, 'nguoiBanHanh')} />
              {
                this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ?
                  <TextArea value={this.state.lyDoBanHanhQuyetDinhGiaiQuyet} className="areal-wrap col-100" label={`Nội dung ${this.state.gqText}`} placeholder="Nhập ..." onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet')} name="lyDoBanHanhQuyetDinhGiaiQuyet"/>
                : null
              }
              {
                this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ?
                  <TextArea value={this.state.lyDoBanHanhQuyetDinhDinhChi} className="areal-wrap col-100" bindValidator={this} channel="formTaoDon" require label="Lý do đình chỉ" placeholder="Nhập lý do" onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi')} name="lyDoBanHanhQuyetDinhDinhChi" maxLength={1000}/>
                : null
              }
              <ShowIf condition={this.state.allowAttach}>
                <div className="col-100 pt15">
                  <ContainerFileDinhKem loaiVanBanSuggest="QDGQ_LDT" quyetDinh={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false} name="QuyetDinhGiaiQuyet" ngayQuyetDinhSuggest={this.state.ngayBanHanh} soVanBanSuggest={this.state.soVanBan} onSave={this.state.onSave} loaiDon={this.state.loaiDon} phanLoaiQuyTrinh='QUYET_DINH_GIAI_QUYET' qDGQText='QDGQ_LDT' qDGQRequired={true} label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                </div>
              </ShowIf>
            </div>

            <div className="col-100 no-gutter pt10 pb20">
              <span className="line-border"></span>
            </div>
            <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
              { this.props.donInfo.layVuViecCu === true &&
                <div className="row pl10 pr10">
                  <DropDownChonKetQuaGiaiQuyet className='col-25' name="ketQuaGiaiQuyetLan2" require bindValidator={this} label='Kết quả giải quyết' selectedValue={this.state.ketQuaGiaiQuyetLan2} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetLan2')}/>

                  { this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' &&
                    <TextArea className='col-100' label='Lý do' require bindValidator={this} channel='formTaoDon' value={this.state.noiDungKetLuanGiaiQuyetLai} onChange={this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai')} name="noiDungKetLuanGiaiQuyetLai" maxLength={1000}/>
                  }
                </div>
              }
              <div className="row pl10 pr10">
                <InputNumber className="col-25 mb0-18" label="Số vụ" value={Number(this.state.soVuGiaiQuyetKhieuNai)} onChange={this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai')} name="soVuDonToCao"/>

                <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO'}>
                  <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.state.loaiDon} label="Kết luận nội dung tố cáo" className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
                </ShowIf>
                <ShowIf condition={this.props.loaiDon != 'DON_TO_CAO'}>
                  <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.state.loaiDon} label="Kết luận nội dung kiến nghị phản ánh" className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
                </ShowIf>
                <Input className="col-25 mb0-18" label="Kết quả khác" name="ketQuaKhac" value={this.state.ketQuaGiaiQuyetKhac} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetKhac')}/>
              </div>
              <div className="row pl10 pr10 mb5">
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ')} name="tienPhaiThuDonToCao"/>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ')} name="datPhaiThuDonToCao"/>
                </div>
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ')} name="tienPhaiTraDonToCao"/>
                  <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'datPhaiTraCongDanQDGQ')} name="datPhaiTraDonToCao"/>
                </div>
                <div className="col-100 no-gutter">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                  <InputNumber className="col-25 mb0-18" label="Tổng số người" value={Number(this.state.tongSoNguoiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh')} name="tongSoNguoiXuLyDonToCao"/>
                  <InputNumber className="col-25 mb0-18" label="Số người đã bị xử lý" value={Number(this.state.soNguoiDaBiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh')} name="soNguoiDaBiXuLyDonToCao"/>
                  <InputNumber className="col-25 mb0-18" label="Số người được trả lại quyền lợi" value={this.state.soNguoiDuocTraLaiQuyenLoi} onChange={this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi')} name="inputnumberSoNguoiTraQuyenLoi"/>
                </div>
              </div>
              <div className="col-100 no-gutter pt10 pb15">
                <span className="line-border"></span>
              </div>
            </ShowIf>

            <div className="col-100 no-gutter">
              <ShowIfCheck label="Chuyển cơ quan điều tra(Nếu có)" onChange={this.handleCheck.bind(this, 'giaoCoQuanDieuTra')} checked={this.state.giaoCoQuanDieuTra}>
                <div className="col-100 no-gutter mt5 pb5">
                  <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                  <div className="row pl10 pr10">
                    <DropDownChonCoQuanDieuTra className="col-25 mb0-18" label="Tên cơ quan" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.coQuanDieuTra} onChange={this.onChange.bind(this, 'coQuanDieuTra')}/>
                    <InputNumber className="col-25 mb0-18" name="soVuGiaoCoQuanDieuTra" label="Số vụ" value={Number(this.state.soVuGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra')}/>
                    <InputNumber className="col-25 mb0-18" name="soDoiTuongGiaoCoQuanDieuTra" label="Số đối tượng" value={Number(this.state.soDoiTuongGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra')} maxLength={255}/>
                    <ShowIf condition={this.state.allowAttachGiaoCoQuanDieuTra}>
                      <div className="col-100 pt15">
                        <ContainerFileDinhKem name="GiaoCQDT" onSave={this.state.onSave} phanLoaiQuyTrinh='GIAO_CO_QUAN_DIEU_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.taiLieuVanThuGiaoCoQuanDieuTra} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                      </div>
                    </ShowIf>
                  </div>
                </div>
                <div className="col-100 no-gutter pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100 no-gutter">
                  <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                    <div className="col-100 no-gutter mt5 pb20">
                      <h2 className="title-12 mb15">Khởi tố</h2>
                      <div className="row pl10 pr10">
                        <div className="col-50 no-gutter">
                          <InputNumber className="col-50 mb0-18" name="soVuBiKhoiTo" label="Số vụ" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                          <InputNumber className="col-50 mb0-18" name="soDoiTuongBiKhoiTo" label="Số đối tượng" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255}/>
                        </div>
                      </div>
                    </div>
                  </ShowIfCheck>
                </div>
              </ShowIfCheck>
            </div>
          </ShowIf>
          <ShowIf condition={this.state.allowAttach}>
            <div className="col-100 no-gutter pb5">
              <ContainerFileDinhKem name="TaiLieuVTGQD" onSave={this.state.onSave} bindValidator={this} data={this.state.listTaiLieuVanThuGiaiQuyetDon} dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView} loaiVanBanSuggest={this.state.loaiVanBanSuggest}
                  ngayQuyetDinhSuggest={this.state.ngayQuyetDinhSuggest} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
            </div>
          </ShowIf>

          <div className="box-bottom no-gutter gqd-wrap col-100">
            <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
            <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialog')}><span>Chuyển theo dõi thực hiện</span></Link>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !this.props.isTTXMLai}>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogGiaoTTXML')}><span>Giao {lb1} lại</span></Link>
            </ShowIf>
            <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this, 'openDialog')} onSuccess={this.onSuccess.bind(this, 'openDialog')} title="Xác nhận" content={`Bạn có đồng ý chuyển đơn/vụ việc này cho ${this.state.tenDonViTheoDoiThucHien} theo dõi thực hiện không?`}/>
            <ConfirmDialog open={this.state.openDialogGiaoTTXML} onClose={this.closeDialog.bind(this,'openDialogGiaoTTXML')} onSuccess={this.onSuccess.bind(this, 'openDialogGiaoTTXML')} title="Xác nhận" content={`Bạn có đồng ý chuyển đơn/vụ việc này cho ${this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : ''} ${lb2} lại không?`}/>
          </div>
        </div>
        <Dialog
        isOpen={this.state.open}
        onClose={this.closeDialogConfirm.bind(this)}
        title='Xác nhận'
        className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">{this.state.message}</p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialogConfirm.bind(this)}><span>Không</span></Link>
            <Link className="btn-green" onClick={this.onSuccessDialogConfirm.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
      </section>
    );
  }
}

LapDuThaoCanBo.defaultProps = {
  isTTXMLai: false,
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(LapDuThaoCanBo);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/LapDuThaoCanBo.jsx